import { render, staticRenderFns } from "./ManagementIndex.vue?vue&type=template&id=3a853421&scoped=true"
import script from "./ManagementIndex.vue?vue&type=script&lang=js"
export * from "./ManagementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a853421",
  null
  
)

export default component.exports